export default {
  namespaced: true,
  state: {
    photo: null,
  },
  getters: {
    // getters
  },
  mutations: {
    setPhoto(state, photo) {
      state.photo = photo;
    },
    clearPhoto(state) {
      state.photo = null;
    },
  },
  actions: {
    clearAll({ commit }) {
      commit('clearPhoto');
    },
  },
};
